import Box from "@subly/s1/ui/atom/Box";
import Form from "@subly/s1/ui/atom/Form";
import Button from "@subly/s1/ui/base/Button";

import { useWelcomeIntegration } from "../fabric";
import Actions from "./Actions";

export default function Integration() {
	const { form } = useWelcomeIntegration();

	return (
		<Form>
			<form.AppForm>
				<Box.Column gap={1.25}>
					<form.AppField name="publicKey" children={(field) => (
						<field.Input
							label="Public Partner Key"
							readOnly
							endAdornment={<Button.Clipboard value={field.state.value} icon iconSize={15} sx={{ p: 0.5 }} />}
						/>
					)} />
					<form.AppField name="privateKey" children={(field) => (
						<field.Input
							label="Private Partner Key - Keep this secret!"
							readOnly
							endAdornment={<Button.Clipboard value={field.state.value} icon iconSize={15} sx={{ p: 0.5 }} />}
						/>
					)} />
				</Box.Column>
				<form.Subscribe selector={(state) => [state.canSubmit, state.isSubmitting]}>
					{([canSubmit, isSubmitting]) => <Actions canSubmit={canSubmit} isSubmitting={isSubmitting} onClick={form.handleSubmit} />}
				</form.Subscribe>
			</form.AppForm>
		</Form>
	);
}